import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import { Observable, map } from 'rxjs';
import {environment} from "../../environments/environment";
import {TripResponse} from "../models/trip.model";

@Injectable({
    providedIn: 'root'
})
export class TripService {

    private apiUrl : string = `${environment.apiUrl}/trip/`;

    constructor(private http: HttpClient) { }

    // Upload CSV -> FastAPI /rider-trips/upload
    uploadCsv(file: File): Observable<any> {
        const form = new FormData();
        form.append('file', file, file.name);
        form.append('created_by', localStorage.getItem('email'));
        form.append('encoding', 'utf-8-sig');
        form.append('delimiter', ',');

        return this.http.post<any>(this.apiUrl+"upload", form);
    }

    fetchTrips(filters : any  = {}): Observable<TripResponse> {

        let params = new HttpParams();

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                let formattedValue = value;

                if (value instanceof Date) {
                    // Format date in local time, not UTC
                    const year = value.getFullYear();
                    const month = String(value.getMonth() + 1).padStart(2, '0');
                    const day = String(value.getDate()).padStart(2, '0');
                    formattedValue = `${year}-${month}-${day}`;
                }

                params = params.set(key, String(formattedValue));

            }
        });

        return this.http.get<TripResponse>(this.apiUrl, {params: params});

    }
}